import React from 'react';
import { Loader } from 'semantic-ui-react';
import './JsonLink.scss';

interface JsonLinksProps {
  dataList: object[] | null | undefined;
  getKey?: (data: object, index: number) => string;
  getName: (data: object, index: number) => string;
  onClick: (data?: object) => void;
}

export const JsonLinks: React.FC<JsonLinksProps> = ({
  dataList,
  getKey,
  getName,
  onClick,
}) => {
  if (dataList === null) {
    return <div>n/a</div>;
  }
  if (dataList) {
    return (
      <>
        {dataList.map((data, index) => (
          <div
            className="lending-support-link"
            key={(getKey ?? getName)(data, index)}
            onClick={() => onClick(data)}
          >
            {getName(data, index)}
          </div>
        ))}
      </>
    );
  }
  return <Loader data-testid="loader" size="small" active={!dataList} inline />;
};
